module.exports = __webpack_public_path__ + "img/FL.6a2bc0a2.png";